import { resetAuthState, startedTempAccessTimeout, } from "../features/auth/authSlice";
import { AUTH_STATUS } from "../lib/constants";
import { EXPERIENCE } from "../constants";
import { PHASE } from "../routeConfig";
import { createSelector } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import useAppDispatch from "./useAppDispatch";
import useAppSelector from "./useAppSelector";
import { useEffect } from "react";
import useHandleAuthValid from "./useHandleAuthValid";
import useMemoryHistory from "./useMemoryHistory";
import { usePreviousImmediate } from "rooks";
function useHandleAuthSuccess(_a) {
    var authStatus = _a.authStatus, resetInMS = _a.resetInMS;
    var isSavvyWidget = useAppSelector(function (state) { return state.configuration.isSavvyWidget; });
    var policyOnly = useAppSelector(function (state) { return state.configuration.policyOnly; });
    var dispatch = useAppDispatch();
    var handleAuthValid = useHandleAuthValid();
    var _b = useMemoryHistory(), push = _b.push, goBack = _b.goBack;
    var prevAuthStatus = usePreviousImmediate(authStatus);
    var isReconnect = useAppSelector(function (state) { return state.configuration.experience === EXPERIENCE.RECONNECT; });
    var didAuth = authStatus === AUTH_STATUS.SUCCESS &&
        typeof prevAuthStatus === "string" &&
        prevAuthStatus !== AUTH_STATUS.SUCCESS;
    useEffect(function () {
        if (!didAuth) {
            return;
        }
        if (!isSavvyWidget || !policyOnly) {
            handleAuthValid();
        }
        var savvyNextRoute = isReconnect
            ? PHASE.RECONNECT_SUCCESS
            : PHASE.QUOTE_CONSENT;
        var nextRoute = isSavvyWidget ? savvyNextRoute : PHASE.COMPLETE;
        push(nextRoute);
    }, [didAuth, isReconnect, isSavvyWidget, policyOnly, push]);
    useEffect(function () {
        if (!didAuth || !resetInMS) {
            return;
        }
        var temporaryAccessKeyReset = window.setTimeout(function () {
            dispatch(resetAuthState());
            goBack();
        }, resetInMS);
        dispatch(startedTempAccessTimeout(temporaryAccessKeyReset));
    }, [didAuth, dispatch, goBack, resetInMS]);
}
var selectResetInMs = function (insuranceType) {
    return createSelector([function (state) { return state.auth[insuranceType].accountInfo; }], function (accountInfo) {
        if (!accountInfo.temporaryAccessKeyExpires || !accountInfo.responseDate) {
            return undefined;
        }
        return dayjs(accountInfo.temporaryAccessKeyExpires).diff(dayjs(accountInfo.responseDate));
    });
};
function useAutoAuthSuccess() {
    var authStatus = useAppSelector(function (state) { return state.auth.auto.status; });
    var resetInMS = useAppSelector(selectResetInMs("auto"));
    useHandleAuthSuccess({
        authStatus: authStatus,
        resetInMS: resetInMS,
    });
}
function useHomeAuthSuccess() {
    var authStatus = useAppSelector(function (state) { return state.auth.home.status; });
    var resetInMS = useAppSelector(selectResetInMs("home"));
    useHandleAuthSuccess({
        authStatus: authStatus,
        resetInMS: resetInMS,
    });
}
export default function useAuthSucces() {
    useAutoAuthSuccess();
    useHomeAuthSuccess();
}
